import { render, staticRenderFns } from "./GalleryContentsLabel.vue?vue&type=template&id=7a71810c&"
import script from "./GalleryContentsLabel.vue?vue&type=script&lang=js&"
export * from "./GalleryContentsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports